import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService, StorageService } from '../../_services/index';
import { DataService, OptionsserviceService, LoansService, OperationsService } from '../../_services/index';

@Component({
  selector: 'app-applicationsguarantors',
  templateUrl: './applicationsguarantors.component.html',
  styleUrls: ['./applicationsguarantors.component.css']
})
export class ApplicationsguarantorsComponent implements OnInit {

  text = 'Guarantors';
  currentUser: any;
  parentRouteId: any;
  sub: any;
  loan: any;
  creating_contract = false;
  has_workflow = false;
  constructor(private dataService: DataService,
    public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public router: Router) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }
  ngOnInit() {
    this.getSummary();
  }
  getSummary() {
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      this.getLoan();
    });

  }
  getLoan() {
    this.loansService.getLoanContract(this.currentUser.token, this.parentRouteId)
      .subscribe(data => {
        this.loan = data.loan;
        this.dataService.onRequestLoadingEndFromBackend.emit();
      });
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({ section: section, request_id: this.parentRouteId });
  }
  doingDisbursement(event) {
    event.new_loan = this.loan;
    this.dataService.disbursingRequest.emit(event);
  }
  openOfferLetter(request_id) {
    this.router.navigate(['./applications/offerletter/' + request_id]);
  }
}
